module.exports = __webpack_public_path__ + "img/yellow_exclamation.2adda355.svg";